export default __webpack_public_path__ + "static/media/last.b096c778.png";